
import axois from 'axios';
import {UserStatusData} from '../../types';

export const setCurrentUserStatus = async (userId: string , userStatusData: UserStatusData): Promise<void> => {
    await axois.put(
        '/api/v2/certification-training/user-status/' + userId,
        userStatusData
    );
};

export const getCurrentUserStatus = async (userId: string): Promise<UserStatusData> => {
    const response = await axois.get<UserStatusData>(
        '/api/v2/certification-training/user-status/' + userId
    );
    return response.data;
};
